
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.75 16.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0Z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"m18.524 10.7.443 1.452a.992.992 0 0 0 1.173.681l1.472-.341a1.339 1.339 0 0 1 1.275 2.218l-1.031 1.111a1 1 0 0 0 0 1.362l1.031 1.111a1.339 1.339 0 0 1-1.275 2.219l-1.472-.342a.993.993 0 0 0-1.173.681l-.443 1.448a1.33 1.33 0 0 1-2.548 0l-.442-1.453a.994.994 0 0 0-1.174-.681l-1.472.342a1.339 1.339 0 0 1-1.274-2.219l1.03-1.111a1 1 0 0 0 0-1.362l-1.03-1.111a1.338 1.338 0 0 1 1.274-2.218l1.472.341a.993.993 0 0 0 1.174-.681l.442-1.452a1.33 1.33 0 0 1 2.548.005Z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M12 23.25A11.25 11.25 0 1 1 23.028 9.767","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M9.289 22.921C7.768 20.689 6.75 16.633 6.75 12S7.768 3.312 9.289 1.079M.775 11.25H9m-6.001-6H21m-18.952 12H9m5.711-16.171a15.282 15.282 0 0 1 2.068 5.632","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    